<template>
  <solution-sheet-sub-item :title="$t('Fibra inferior')">
    <p v-if="isWithoutRestraints">{{ $t("Nenhum vão com travamento") }}</p>

    <template v-else>
      <p>{{ $t("Travamentos laterais") }}:</p>

      <template v-for="(val, i) in lowerFibreValue">
        <p v-if="val !== 0" :key="i">V{{ i + 1 }}: {{ val }}</p>
      </template>
    </template>
  </solution-sheet-sub-item>
</template>

<script>
import { withoutDuplicates } from "@/utils";
import { SolutionSheetSubItem } from "@/components";

export default {
  components: {
    SolutionSheetSubItem,
  },

  props: {
    lowerFibreValue: {
      type: Array,
      required: true,
    },
  },

  computed: {
    isWithoutRestraints() {
      return (
        withoutDuplicates(this.lowerFibreValue).length === 1 &&
        this.lowerFibreValue[0] === 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
